import React, { useEffect, useState } from "react";
import {
  FiSettings,
  FiBarChart2,
  FiLogOut,
} from "react-icons/fi";
import api from "../../Services/Api";

const getResolvedProfileImageUrl = (profileImageUrl) => {
  if (!profileImageUrl) {
    return "";
  }

  try {
    return new URL(profileImageUrl, api.defaults.baseURL).toString();
  } catch (error) {
    return profileImageUrl;
  }
};

function UserDropdown({ user, onLogout, onAccountSettings }) {
  const [visible, setVisible] = useState(false);
  const [profileImageFailed, setProfileImageFailed] = useState(false);

  useEffect(() => {
    const id = requestAnimationFrame(() => setVisible(true));
    return () => cancelAnimationFrame(id);
  }, []);

  useEffect(() => {
    setProfileImageFailed(false);
  }, [user?.profileImageUrl]);

  const getInitials = (name) => {
    if (!name) return "";

    return name
      .split(" ")
      .filter(Boolean)
      .map((word) => word[0].toUpperCase())
      .slice(0, 2) // only first 2 letters
      .join("");
  };

  return (
    <div
      className={`absolute right-0 top-full z-50 mt-4 w-[min(20rem,calc(100vw-2rem))] origin-top-right transform transition-all duration-200 ease-out ${
        visible
          ? "opacity-100 translate-y-0 scale-100"
          : "opacity-0 -translate-y-2 scale-95"
      }`}
      role="menu"
    >
      <div className="rounded-2xl bg-white border border-neutral-border shadow-[0_20px_60px_rgba(16,42,107,0.15)] overflow-hidden">

        {/* Profile Section */}
        <div className="flex items-center gap-4 p-5 border-b border-neutral-border bg-neutral-light">
          {user.profileImageUrl && !profileImageFailed ? (
            <img
              src={getResolvedProfileImageUrl(user.profileImageUrl)}
              alt={user.name ?? "Profile"}
              className="h-12 w-12 rounded-full border border-primary-dark object-cover"
              onError={() => setProfileImageFailed(true)}
            />
          ) : (
            <div className="w-12 h-12 rounded-full bg-primary-default text-white flex items-center justify-center text-lg font-semibold">
              {getInitials(user.name)}
            </div>
          )}

          <div>
            <div className="flex items-center gap-2">
              <h3 className="font-semibold text-primary-dark">
                {user.name}
              </h3>
              <span className="text-[10px] px-2 py-0.5 rounded-full bg-accent-gold/20 text-accent-gold font-medium">
                CEO
              </span>
            </div>
            <p className="text-xs text-neutral-textSecondary">
              {user.email}
            </p>
          </div>
        </div>

        {/* Menu Items */}
        <div className="p-3 space-y-1 text-sm">
          <MenuItem
            icon={<FiSettings />}
            label="Account Settings"
            onClick={onAccountSettings}
          />
          {/* <MenuItem icon={<FiMoon />} label="Dark Mode" /> */}
          <MenuItem icon={<FiBarChart2 />} label="View Analytics" />

          <div className="border-t border-neutral-border my-2"></div>

          <button
            onClick={onLogout}
            className="flex items-center gap-3 w-full px-3 py-2 rounded-lg text-error hover:bg-error/10 transition"
          >
            <FiLogOut />
            Logout
          </button>
        </div>
      </div>
    </div>
  );
}

function MenuItem({ icon, label, onClick }) {
  return (
    <button
      onClick={onClick}
      className="flex items-center gap-3 w-full px-3 py-2 rounded-lg text-neutral-textSecondary hover:bg-primary-default/5 hover:text-primary-default transition"
    >
      <span className="text-base">{icon}</span>
      {label}
    </button>
  );
}

export default UserDropdown;
